import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import { IconChevronDown, IconChevronUp } from '@carnica/graphics';
import { Text } from '@carnica/ui-kit';
import React from 'react';
import { cnBem } from '@carnica/utils';
import { motion } from 'framer-motion';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import styles from "./styles.pcss";
import { useSearchNavigation } from "../../lib";
var cnNavigation = cnBem('navigation', styles);
export var Navigation = function Navigation(_ref) {
  var className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useSearchNavigation = useSearchNavigation(),
    upDisabled = _useSearchNavigation.upDisabled,
    downDisabled = _useSearchNavigation.downDisabled,
    count = _useSearchNavigation.count,
    hidden = _useSearchNavigation.hidden,
    position = _useSearchNavigation.position,
    setPosition = _useSearchNavigation.setPosition;
  return /*#__PURE__*/React.createElement(motion.div, _extends({
    animate: {
      height: !hidden ? 70 : 0,
      y: !hidden ? 0 : 100
    },
    className: cnNavigation({
      hidden: hidden
    }, [className, cnComponentsTheme('dark')]),
    transition: {
      y: {
        duration: 0.4
      },
      height: {
        duration: 0.1
      }
    }
  }, otherProps), /*#__PURE__*/React.createElement(Text, {
    color: "tertiary-invert",
    variant: "body-small",
    "data-t-id": "ui-Navigation"
  }, "".concat(position, " \u0438\u0437 ").concat(count)), /*#__PURE__*/React.createElement("div", {
    className: cnNavigation('controls')
  }, /*#__PURE__*/React.createElement(IconChevronUp, {
    className: cnNavigation('button'),
    color: upDisabled ? 'disabled' : 'primary',
    disabled: upDisabled,
    onClick: function onClick() {
      return setPosition(function (prev) {
        return prev + 1;
      });
    },
    size: "m",
    tagName: "button"
  }), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: cnNavigation('button'),
    color: downDisabled ? 'disabled' : 'primary',
    disabled: downDisabled,
    onClick: function onClick() {
      return setPosition(function (prev) {
        return prev - 1;
      });
    },
    size: "m",
    tagName: "button"
  })));
};